import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";
import { slugify } from "./Seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BrowseHub = () => {
  const [meta, setMeta] = useState(null);
  const [counts, setCounts] = useState({ byCat: {}, bySt: {} });

  useEffect(() => {
    axios.get(`${API}/meta`).then((r) => setMeta(r.data)).catch(() => {});
    // fetch counts per category (parallel lightweight queries via facet would be ideal, but /institutions supports total)
  }, []);

  if (!meta) return null;

  // Defensive — API may return a partial payload or an error shape.
  const categories = Array.isArray(meta.categories) ? meta.categories : [];
  const states = Array.isArray(meta.states) ? meta.states : [];
  if (categories.length === 0 && states.length === 0) return null;

  return (
    <section
      id="browse"
      data-testid="browse-hub"
      className="border-b border-[#0A0A0A] bg-white"
      aria-labelledby="browse-heading"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-8 lg:px-12 py-12">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-8 h-px bg-[#0A0A0A]" />
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#4B5563]">
            Browse hub · Section 03
          </span>
        </div>
        <h2 id="browse-heading" className="font-display font-black text-3xl md:text-5xl tracking-tighter mb-10">
          Jump directly into any
          <br />
          <span className="text-[#002FA7]">category or state.</span>
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {/* Categories */}
          <div>
            <div className="flex items-baseline justify-between border-b border-[#0A0A0A] pb-2 mb-4">
              <h3 className="font-display font-bold text-xl tracking-tight">By Category</h3>
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#4B5563]">
                {categories.length} types
              </span>
            </div>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6">
              {categories.map((c) => (
                <li key={c} className="border-b border-[#E5E7EB] last:border-b-0">
                  <Link
                    to={`/category/${slugify(c)}`}
                    data-testid={`browse-cat-${slugify(c)}`}
                    className="flex items-center justify-between py-3 text-sm hover:text-[#002FA7] transition-colors"
                  >
                    <span className="font-medium">{c}</span>
                    <ArrowUpRight className="w-3.5 h-3.5 text-[#4B5563]" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* States */}
          <div>
            <div className="flex items-baseline justify-between border-b border-[#0A0A0A] pb-2 mb-4">
              <h3 className="font-display font-bold text-xl tracking-tight">By State</h3>
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#4B5563]">
                {states.length} states/UTs
              </span>
            </div>
            <ul className="grid grid-cols-2 sm:grid-cols-3 gap-x-6">
              {states.map((s) => (
                <li key={s} className="border-b border-[#E5E7EB] last:border-b-0">
                  <Link
                    to={`/state/${slugify(s)}`}
                    data-testid={`browse-state-${slugify(s)}`}
                    className="flex items-center justify-between py-3 text-sm hover:text-[#002FA7] transition-colors"
                  >
                    <span className="font-medium">{s}</span>
                    <ArrowUpRight className="w-3.5 h-3.5 text-[#4B5563]" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
